import React from "react";

const EditSiteType = ({ onSubmit, onCancel, currentValue }) => {
  const nameRef = React.createRef();
  setTimeout(() => {
    if (nameRef && nameRef.current) {
      nameRef.current.value = currentValue;
    }
  }, 0);

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        const name = nameRef.current.value;
        onSubmit(name);
      }}
    >
      <div className="form-row">
        <div className="col-md-8">
          <input
            type="text"
            ref={nameRef}
            required
            placeholder="Enter site type"
            className="form-control input-height"
          />
        </div>

        {/* Update button */}
        <div className="col">
          <button
            type="submit"
            className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
          >
            Update
            <i className="material-icons">arrow_right_alt</i>
          </button>
        </div>

        {/* Cancel button */}
        <div className="col">
          <button
            onClick={onCancel}
            type="button"
            className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-default"
          >
            <i className="material-icons text-danger">cancel</i>
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};

export default EditSiteType;
